import React from 'react';
import './TopBar.css';

export default function TopBar({ user, onLogout, title, onBack }) {
  return (
    <div className="topbar">
      <div className="topbar-left">
        {onBack ? (
          <button className="topbar-back" onClick={onBack} aria-label="Voltar">
            ←
          </button>
        ) : (
          <div className="topbar-brand">
            <span className="topbar-dove">🕊</span>
            <span className="topbar-name">POMBO</span>
          </div>
        )}
      </div>
      {title && <span className="topbar-title">{title}</span>}
      <div className="topbar-right">
        {user && (
          <button className="topbar-avatar" onClick={onLogout} title="Sair">
            {user.nome?.charAt(0).toUpperCase() || 'U'}
          </button>
        )}
      </div>
    </div>
  );
}
